import React from 'react';
import { Scale, FileText, Ship, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { practiceAreas } from '../data/mock';

const iconMap = {
  Scale: Scale,
  FileText: FileText,
  Ship: Ship
};

const PracticeAreas = () => {
  return (
    <section id="areas" className="py-20 bg-slate-950">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Áreas de <span className="text-yellow-400">Práctica</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Brindamos asesoramiento legal especializado en tres ramas fundamentales del derecho
          </p>
        </div>

        {/* Practice Areas Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          {practiceAreas.map((area) => {
            const IconComponent = iconMap[area.icon];
            return (
              <Card 
                key={area.id}
                className="bg-gray-800 border-gray-700 hover:border-gray-600 transition-all duration-300 hover:shadow-xl hover:shadow-gray-600/10 flex flex-col h-full"
              >
                <CardHeader className="flex-grow">
                  <div className="flex justify-center mb-4">
                    <div className="inline-flex p-3 rounded-lg bg-slate-800">
                      <IconComponent 
                        className="text-gray-400" 
                        size={32} 
                      />
                    </div>
                  </div>
                  <CardTitle className="text-2xl text-white mb-2 text-center">
                    {area.title}
                  </CardTitle>
                  {area.featured && (
                    <div className="flex justify-center mb-2">
                      <div className="inline-block bg-yellow-500 text-black text-xs font-semibold px-3 py-1 rounded-full">
                        Especialización Principal
                      </div>
                    </div>
                  )}
                  <CardDescription className="text-gray-400 text-base leading-relaxed text-center">
                    {area.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    {area.services.map((service, index) => (
                      <li key={index} className="flex items-start space-x-2">
                        <CheckCircle className="text-gray-400 mt-1 flex-shrink-0" size={16} />
                        <span className="text-gray-300 text-sm">{service}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional Info Banner */}
        <div className="bg-gradient-to-r from-blue-900/20 to-blue-800/20 border border-blue-700/30 rounded-xl p-8 text-center">
          <h3 className="text-2xl font-bold text-white mb-3">
            ¿Necesita Asesoramiento Legal Especializado?
          </h3>
          <p className="text-gray-300 mb-6 max-w-2xl mx-auto">
            Nuestro equipo está preparado para analizar su caso y brindarle la mejor estrategia legal
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contacto');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-gray-700 hover:bg-gray-600 text-white font-semibold px-8 py-3 rounded-lg transition-colors"
          >
            Solicitar Consulta
          </button>
        </div>
      </div>
    </section>
  );
};

export default PracticeAreas;
